import { RDEqipEligibilityFarmInfo } from '@cibo/core'
import { DataGridPro, Markdown, ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { GridRowHeightReturnValue } from '@mui/x-data-grid-pro'
import { ReactNode, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { fieldNameColumn } from '../../../components'
import { useFields, useUpdateMultipleFields } from '../../../queries'
import { FarmInfoCellEditor } from './FarmInfoCellEditor'

export const FarmInfoTaskEditor = ({
  ownerName,
  userRole,
  resourceIds,
}: ResourceDetailFeatureTaskEditorProps<RDEqipEligibilityFarmInfo>) => {
  const { data: fieldModels, isLoading } = useFields(resourceIds)
  const { t } = useTranslation('@cibo/landmanager/FarmInfo')
  const updateFields = useUpdateMultipleFields()

  const columns = useMemo(() => {
    return [
      fieldNameColumn({ t }),
      {
        field: 'answer',
        headerName: t('answer', { ns: '@cibo/landmanager/DetailEditing' }),
        hideable: false,
        flex: 1,
        minWidth: 220,
        filterable: false,
        renderCell: FarmInfoCellEditor,
      },
    ]
  }, [])

  const getRowHeight = useCallback((): GridRowHeightReturnValue => 'auto', [])
  return (
    <Stack spacing={3}>
      <Markdown
        overrides={{
          em: {
            component: ({ children }: { children: ReactNode }) => (
              <>
                <br />
                <Typography variant="body2" color="text.secondary" component="span">
                  {children}
                </Typography>
              </>
            ),
          },
        }}
      >
        {t('tableCta', { context: userRole, name: ownerName })}
      </Markdown>
      <DataGridPro
        rows={fieldModels || []}
        getRowHeight={getRowHeight}
        columns={columns}
        loading={isLoading || updateFields.isLoading}
        autoHeight
      />
    </Stack>
  )
}
